import { gql } from 'apollo-boost';


export const fragments = {

    MILESTONES: {
        QUERY_RETURN: `id name description refIdCode resourceCode colorValue iconName isArchived contextOwner`,
    },

    MILESTONE: {
        QUERY_RETURN:    `id name description refIdCode resourceCode colorValue iconName isArchived contextOwner`,
        MUTATION_RETURN: `id name description refIdCode resourceCode colorValue iconName isArchived`,
        EDIT_FIELDS:     `id name description refIdCode resourceCode colorValue iconName isArchived`,
    },
};

export const queries = {

    GET_MILESTONES: ( returnQueryString = fragments.MILESTONES.QUERY_RETURN ) => {

        const query = `
            query GetMilestones(
                $order: [MilestoneSortInput!],
                $where: MilestoneFilterInput ){
                milestones( order: $order, where: $where){
                    ${ returnQueryString }
                }
            }`;

        return gql( query );
    },

    GET_MILESTONE: ( returnQueryString = fragments.MILESTONE.QUERY_RETURN ) => {

        const query = `
            query GetMilestone( $id: Uuid! ){
                milestones( where: { id: { eq: $id } } ) {
                    ${ returnQueryString }
                }
            }`;

        return gql( query );
    },

};

export const mutations = {

    /* MILESTONES */

    CREATE_MILESTONE: ( returnQueryString = fragments.MILESTONE.MUTATION_RETURN ) => {

        const query = `
            mutation CreateMilestone( $input: MilestoneCreateCommandInput! ){
                createMilestone( input: $input ) {
                    ${ returnQueryString }
                }
            }`;

        return gql( query );
    },

    UPDATE_MILESTONE: ( returnQueryString = fragments.MILESTONE.MUTATION_RETURN ) => {

        const query = `
            mutation UpdateMilestone( $input: MilestoneUpdateCommandInput! ){
                updateMilestone( input: $input ) {
                    ${ returnQueryString }
                }
            }`;

        return gql( query );
    },

    // DELETE_MILESTONE: () => {
    //
    //     const query = `
    //         mutation DeleteMilestone( $input: MilestoneDeleteCommandInput! ){
    //             deleteMilestone( input: $input )
    //         }`;
    //
    //     return gql( query );
    // },
};

export const functions = {};

export const MilestoneQueries = {
    fragments,
    queries,
    mutations,
    functions,
};